import { apiClient } from './client';

export interface AuditEntry {
  id: string;
  paymentId: string;
  paymentType: string;
  amount: string;
  clientId: string;
  clientName: string | null;
  casinoUser: string | null;
  action: string;
  actor: string;
  detail: string | null;
  timestamp: string;
}

export interface ListAuditParams {
  action?: string;
  actorId?: string;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  offset?: number;
}

export const auditApi = {
  list: async (params: ListAuditParams = {}): Promise<AuditEntry[]> => {
    const { data } = await apiClient.get('/admin/audit', { params });
    return data as AuditEntry[];
  },

  exportCsv: async (params: ListAuditParams = {}): Promise<string> => {
    const { data } = await apiClient.get('/admin/audit/export', { params });
    return data as string;
  },
};
